import { Container, IconButton, Typography } from "@mui/material";
import { TbArrowBigLeftLinesFilled} from 'react-icons/tb';
import { PiMaskSadFill } from "react-icons/pi";
import { useNavigate } from 'react-router-dom';

export const ErrorLoginPage:React.FC<{}> = () => {
    let history = useNavigate();

    return(
        <Container maxWidth="sm">
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <Typography variant="h4" component="h1">
          Alerta
        </Typography>
        <Typography variant="h6">La sesión caducó.</Typography>
        <IconButton aria-label="delete" color="error" sx={{ fontSize: '360px'}}>
        <PiMaskSadFill />
        </IconButton>
        <br />
        <IconButton aria-label="delete" color="primary" onClick={() => {history('/')}}>
        <TbArrowBigLeftLinesFilled />
        </IconButton>         
      </div>
    </Container>
    );
}